module.exports = __webpack_public_path__ + "static/media/logo2.071bd8f6.png";